import React from 'react';
import ModernDatePicker from 'src/components/SharedComponents/ModernDatePicker/ModernDatePicker';
import './ReportDateRange.scss';

export interface ReportDateRangeProps {
  fromDate: Date | null;
  toDate: Date | null;
  onFromDateChange: (nextFromDate: Date | null) => void;
  onToDateChange: (nextToDate: Date | null) => void;
}

export const ReportDateRange = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
}: ReportDateRangeProps) => {
  return (
    <div className="report-date-range">
      <div className="reporting__heading">SELECT REPORT DATES</div>

      <ModernDatePicker
        label="From Date"
        labelAlign="left"
        value={fromDate}
        onChange={onFromDateChange}
        placeholder="From Date"
      />

      <ModernDatePicker
        label="To Date"
        labelAlign="left"
        value={toDate}
        onChange={onToDateChange}
        placeholder="To Date"
      />
    </div>
  );
};
